import React from "react";

import { Icon } from "components/Icon/Icon";
import { useCopiedItem, useSetCopiedItem } from "stores/project";
import * as identify from "utils/treeUtils";
import { useTranslate } from "hooks";
import { getLocalPath } from "utils";

export const Clipboard = () => {
  const translate = useTranslate();
  const copiedItem = useCopiedItem();
  const setCopiedItem = useSetCopiedItem();

  if (copiedItem === null) {
    return;
  }

  const { data } = copiedItem;

  const isAnyProduct = identify.isAnyProduct(data);

  return (
    <div
      className="h-100 w-100 position-absolute top-0 p-5 border bg-white d-flex justify-content-between flex-nowrap align-items-center"
      style={{ zIndex: "9999" }}
    >
      <div className="d-flex flex-column">
        <h5 className="mb-0">Clipboard</h5>
        <div className="d-flex flex-nowrap">
          {isAnyProduct ? (
            <>
              <div className="pe-2 border-end">{data.productName}</div>
              <div className="px-2 border-end">
                {translate("QUANTITY")}: {data.quantity}
              </div>
              <div className="ps-2">
                {`${translate("PRESENTATION_ORDER_CODE")}: ${data.presentation}`}
              </div>
            </>
          ) : (
            <div>{getLocalPath(copiedItem)}</div>
          )}
        </div>
      </div>
      <div
        className="d-flex align-items-center cursor-pointer"
        onClick={() => setCopiedItem(null)}
      >
        Cancel
        <Icon iconName="xmark-regular" className="ms-2 icon-16" />
      </div>
    </div>
  );
};
